module.exports = __webpack_public_path__ + "b8a2625e7b43e83389c226b85f1e7c8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/combined-phones.png
// module id = 2093
// module chunks = 1